import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

// FontAwesome "note-sticky" (solid), inlined from the estimateNext design — the work order's Crew
// Note label. MUI's Note is an outlined page with a folded top corner; the design's is a filled
// square notched at the bottom-right. Inherits color via `currentColor`.
const StickyNoteIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path d="M2.4 3.2C2.4 2.3163 3.1163 1.6 4 1.6H12C12.8837 1.6 13.6 2.3163 13.6 3.2V9.6H10.4C9.9582 9.6 9.6 9.9582 9.6 10.4V13.6H4C3.1163 13.6 2.4 12.8837 2.4 12V3.2ZM10.8 13.36L13.36 10.8H10.8V13.36Z" />
  </SvgIcon>
)
export default StickyNoteIcon
